import React from 'react';
import PacksManager from '../components/PacksManager';

// Página para gerenciar os packs (criar, editar, adicionar perguntas)
export default function PacksManagerPage() {
  return <PacksManager />;
}
